module.exports = __webpack_public_path__ + "static/media/terranova-512.11f4d73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/terranova-512.png
// module id = 787
// module chunks = 0